import { __ } from '@wordpress/i18n';

export const DEFAULT_UNITS = [
	{ value: 'px', label: __( 'px', 'redfox-thank-you' ), default: 0 },
	{ value: 'em', label: __( 'em', 'redfox-thank-you' ), default: 0 },
	{ value: 'rem', label: __( 'rem', 'redfox-thank-you' ), default: 0 },
	{ value: '%', label: __( '%', 'redfox-thank-you' ), default: 0 },
	{ value: 'vw', label: __( 'vw', 'redfox-thank-you' ), default: 0 },
	{ value: 'vh', label: __( 'vh', 'redfox-thank-you' ), default: 0 },
];

export const DEFAULT_SIDES = {
	top: __( 'Top', 'redfox-thank-you' ),
	right: __( 'Right', 'redfox-thank-you' ),
	bottom: __( 'Bottom', 'redfox-thank-you' ),
	left: __( 'Left', 'redfox-thank-you' ),
};

export const BOX_CONTROL_LABELS = {
	linkSides: __( 'Link sides', 'redfox-thank-you' ),
	unlinkSides: __( 'Unlink sides', 'redfox-thank-you' ),
};
